import { render, staticRenderFns } from "./AddAutoVehicle.vue?vue&type=template&id=6cf9c37a&scoped=true"
import script from "./AddAutoVehicle.vue?vue&type=script&lang=ts"
export * from "./AddAutoVehicle.vue?vue&type=script&lang=ts"
import style0 from "./AddAutoVehicle.vue?vue&type=style&index=0&id=6cf9c37a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf9c37a",
  null
  
)

export default component.exports